var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{ref:"subnavItem",staticClass:"subnav__items",class:{ 'is-active-sub' : _vm.active },style:(`margin-top: ${_vm.subnavitem_h}px`)},[_c('div',{staticClass:"nav__title -sub"},[_c('span',[_vm._t("label")],2),_c('router-link',{attrs:{"to":_vm.path}})],1),(_vm.hasSubnav)?_vm._t("subnav"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }